var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 20,
  viewBox: "0 0 10 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Polygon_45",
  "data-name": "Polygon 45",
  d: "M10,0,20,10H0Z",
  transform: "translate(10) rotate(90)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/PlayWhite.2227b77d.svg";
export { SvgComponent as ReactComponent };